export default __webpack_public_path__ + "static/media/TVS KING GS+ ESPECIAL_2.07b1ab03.webp";